import gsap from 'gsap';
import './effects';

export default class Loader {
    static init() {
        // Loader
        if (document.querySelectorAll('.loader').length == 0) {
            return;
        }

        this.setupGrid();
        window.addEventListener('resize', () => {
            this.setupGrid();
        });

        this.MIN_DELAY = false;

        this.INTERVAL = 700;
        this.OFFSET = 500;

        window.setTimeout(() => {
            this.MIN_DELAY = true;
        }, 2000);

        this.animation();
        
        const btn = document.querySelector('.loader__close');
        if(btn) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeLoader();
            });
        }

        const btnNews = document.querySelector('.loader__closeNews');
        if(btnNews) {
            btnNews.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeLoader();
            });
        }
    }

    static animation() {
        let lastValue = 64;
        this.CURRENT = lastValue + (lastValue * 0.2);

        this.INTERVALID = window.setInterval(() => {
            let prefix = '0';
            let v = this.getRandomArbitrary(lastValue, lastValue + (lastValue * 0.2)).toFixed(0);
            lastValue = parseFloat(v);
            if (v < 10) {
                prefix = '00';
            } else {
                prefix = '0';
            }
            document.querySelector('.loader__value').innerText = `${prefix}${v}%`;
            if (this.MIN_DELAY) {
                window.clearInterval(this.INTERVALID);
                document.querySelector('.loader__value').innerText = `100%`;
            }
        }, this.INTERVAL);

        gsap.effects.letters(document.querySelectorAll('.loader__footerText span'));
        window.setTimeout(() => {
            gsap.to(
                document.querySelectorAll('.loader__title, .loader__news, .loader__close'),
                {
                    duration: 0.85,
                    opacity: 1,
                    y: 0,
                    rotate: 0,
                    ease: 'power4.out',
                    stagger: 0.1,
                }
            );
        }, this.OFFSET);
    }

    static getRandomArbitrary(min, max) {
        return Math.random() * (max - min) + min;
    }

    static setupGrid() {
        this.allItems = document.querySelectorAll('.loader__news');
        for (let x = 0; x < this.allItems.length; x++) {
            this.grid(this.allItems[x]);
        }
    }

    static grid(item) {
        const grid = document.querySelector('.loader__wrapper');
        const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
        const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
        const rowSpan = Math.ceil((item.querySelector('.loader__newsContent').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
        item.style.gridRowEnd = 'span ' + rowSpan;
    }

    static closeLoader() {
        document.querySelector('.loader').style.pointerEvents = 'none';
        gsap.to(
            document.querySelectorAll('.loader'),
            {
                duration: 0.85,
                opacity: 0,
                ease: 'power4.out',
            }
        );
        document.querySelector('.loader').classList.remove('js-news');
    }

    static openLoader(classes) {
        document.querySelector('.loader').style.pointerEvents = '';
        gsap.to(
            document.querySelectorAll('.loader'),
            {
                duration: 0.85,
                opacity: 1,
                ease: 'power4.out',
            }
        );
        if(classes) {
            document.querySelector('.loader').classList.add('js-news');
        }
    }
}